const cleaningAreasReducer = (state = [], action) => {
    switch (action.type) {
        case "appendCleaningAreas":
            return [...state, action.payload];
        default:
            return state;
    }
};

export default cleaningAreasReducer;
